const IS_TEST = process.env.NODE_ENV === 'test';
const IS_E2E = process.env.IS_E2E === 'true';
const IS_CI = process.env.CI === 'true';

const IS_BROWSER = typeof window !== 'undefined';
const IS_SERVER = typeof window === 'undefined';

const IS_DEV = process.env.NODE_ENV === 'development';
const IS_PROD = !IS_DEV;
const IS_PREVIEW = process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV === 'preview';

const getBranchNameFromUrl = (url?: string) => {
  if (!url) {
    return '';
  }
  const match = url.match(/^[^-]+-(.+\.preview\.onefootprint\.com)$/);
  return match ? match[1] : '';
};

const branchUrl = getBranchNameFromUrl(process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL);

const createUrl = ({ port, previewAlias, prodAlias }: { port: string; previewAlias: string; prodAlias: string }) => {
  if (IS_DEV || IS_E2E) {
    return `http://localhost:${port}`;
  }

  if (IS_PREVIEW) {
    return branchUrl ? `https://${previewAlias}-${branchUrl}` : `https://${prodAlias}.preview.onefootprint.com`;
  }

  return `https://${prodAlias}.onefootprint.com`;
};

const DEMO_BASE_URL = createUrl({ port: '3002', previewAlias: 'demos', prodAlias: 'demo' });

const DASHBOARD_BASE_URL = createUrl({ port: '3001', previewAlias: 'dashboard', prodAlias: 'dashboard' });

const HOSTED_BASE_URL = createUrl({ port: '3004', previewAlias: 'hosted', prodAlias: 'verify' });

const AUTH_BASE_URL = createUrl({ port: '3011', previewAlias: 'auth', prodAlias: 'auth' });

// Handoff is the only base URL that has to be reachable from another device: it runs on a phone,
// which can't resolve localhost and needs HTTPS for the camera. `pnpm dev:handoff-tunnel` sets this.
const HANDOFF_BASE_URL =
  (IS_DEV && process.env.NEXT_PUBLIC_HANDOFF_BASE_URL) ||
  createUrl({
    port: '3005',
    previewAlias: 'handoff',
    prodAlias: 'handoff',
  });

const DOCS_BASE_URL = createUrl({ port: '3009', previewAlias: 'docs', prodAlias: 'docs' });

export {
  AUTH_BASE_URL,
  DASHBOARD_BASE_URL,
  DEMO_BASE_URL,
  DOCS_BASE_URL,
  HANDOFF_BASE_URL,
  HOSTED_BASE_URL,
  IS_BROWSER,
  IS_CI,
  IS_DEV,
  IS_E2E,
  IS_PREVIEW,
  IS_PROD,
  IS_SERVER,
  IS_TEST,
};
